const general = {
  all: 'Tous',
  apply: 'Appliquer',
  category: 'Catégorie',
  categories: 'Catégories',
  custom: 'Personnalisé',
  doors: 'Portes',
  resetDate: 'Réinitialiser la date',
  resetFilters: 'Réinitialiser les filtres',
  users: 'Utilisateurs',
  legend: 'Légende',
  export: 'Exporter',
  export_all: 'Exporter tout',
  organizations: 'Comptes',
  download_started: 'Téléchargement lancé',
  delay: 'Délai',
  entry_reader: 'Lecteur d’entrée',
  exit_reader: 'Lecteur de sortie',
  door: 'Porte',
  schedule: 'Horaire',
  user: 'Utilisateur',
  account: 'Compte',
  unassign: 'Désattribuer',
  assigned: 'Assigné',
  unassigned: 'Non assigné',
  unused_since: 'Inutilisé depuis',
  unused_since_options: {
    any: 'Indifférent',
    last_month: 'Dernier mois',
    last_3_months: '3 mois',
    last_6_months: '6 mois',
    never: 'Jamais',
  },
  clear: 'Effacer',
  access_levels: 'Niveaux d’accès',
  activation: 'Activation',
  expiration: 'Expiration',
  credentials: 'Identifiants',
  dataLoadingFailed:
    'Une erreur s’est produite lors du chargement des données.',
  role: 'Rôle',
  roles: 'Rôles',
  failed: 'Échoué',
  inputs: 'Entrées',
  keypad_code: 'Code clavier',
  not_assigned: 'Non assigné',
  pending: 'En attente',
  ping: 'Ping',
  contactYourDealer: 'Contactez votre installateur',
  controller: 'Contrôleur',
  date_and_time: 'Date et heure',
  description: 'Description',
  details: 'Détails',
  name: 'Nom',
  object_type: 'Type d’objet',
  site: 'Site',
  sites_assigned: 'Sites assignés',
  active: 'Actif',
  inactive: 'Inactif',
  deactivate: 'Désactiver',
  yes: 'Oui',
  no: 'No',
  boolean_none: 'Aucun',
  boolean_false: 'Faux',
  boolean_true: 'Vrai',
  day: 'Jour',
  hour: 'Heure',
  minute: 'Minute',
  the: 'La',
  yearly: 'Annuel',
  on: 'Sur',
  and: 'Et',
  welcome: 'Bienvenue',
  online: 'En ligne',
  offline: 'Hors ligne',
  all_sites: 'Tous les sites',
  access_all_accounts: 'Accès à tous les comptes, y compris les nouveaux',
  refresh: 'Actualiser',
  success: 'Succès',
  error: 'Erreur',
  kprog_error: 'Kprog Erreur',
  delete_message: 'Etes-vous sûr de vouloir supprimer',
  are_you_sure: 'Êtes-vous sûr ?',
  replacing: 'Remplacement',
  rebooting: 'Redémarrage',
  from: 'De',
  to: 'Pour',
  to_label: 'à',
  status_label: 'État :',
  general: 'Général',
  confirmation: 'Confirmation',
  filters: 'Filtres',
  search: 'Rechercher',
  results: 'Résultats',
  loading: 'Chargement',
  loading_ellipsis: 'Chargement...',
  reason: 'Raison',
  alerts: 'Alertes',
  multisite: 'Multisite',
  comments: 'Commentaires',
  leave_message:
    'Êtes-vous sûr de vouloir quitter? Toutes les modifications non enregistrées seront perdues.',
  quantity: 'Quantité',
  status: 'Statut',
  summary: 'Résumé',
  general_information: 'Informations générales',
  activate: 'Activer',
  events: 'Événements',
  save: 'Sauvegarder',
  enabled: 'Activé',
  today: "Aujourd'hui",
  yesterday: 'Hier',
  launch: 'Lancer',
  enable: 'Activer',
  finished: 'Terminer',
  settings: 'Paramètres',
  more_filters: 'Plus de filtres',
  radio_options: 'Options radio',
  invalid_date: 'Date invalide',
  field_required: 'Ce champ est obligatoire',
  date_after: 'La date doit être à ou après {{date}}',
  date_before: 'La date doit être à ou avant {{date}}',
  date_from_before_to: 'La date de début doit être avant la date de fin',
  date_to_after_from: 'La date de fin doit être après la date de début',
  date_from_too_late: 'Doit être antérieure ou égale à la date de fin',
  date_to_too_early: 'Doit être postérieure ou égale à la date de début',
  file_too_big:
    'Le fichier est trop lourd ! Veuillez sélectionner un fichier de moins de 1 Mo',
  state: 'État',
  back_to_list: 'Retour à la liste',
  company: 'Entreprise',
  country: 'Pays',
  city: 'Ville',
  phone: 'Téléphone',
  address: 'Adresse',
  none: 'Aucun',
  no_image: 'Aucune image',
  unknown: 'Inconnu',
  object: 'Objet',
  type: 'Type',
  id: 'ID',
  display_name: "Nom d'affichage",
  serial_number: 'Numéro de série',
  format: 'Format',
  formats: 'Formats',
  site_name: 'Nom du site',
  replace: 'Remplacer',
  cancel: 'Annuler',
  close: 'Fermer',
  profile: 'Profil',
  province_territory: 'Province ou territoire',
  zip_code: 'Code postal',
  postal_code: 'Code postal',
  email: 'Courriel',
  first_name: 'Prénom',
  last_name: 'Nom de famille',
  full_name: 'Nom et prénom',
  start: 'Commencer',
  stop: 'Arrêter',
  purchase: 'Achat',
  date: 'Date',
  title: 'Titre',
  event: 'Événement',
  btn: {
    buy: 'Acheter',
    discontinue: 'Cesser',
    continue: 'Continuer',
    back: 'Retour',
    open: 'Ouverte',
    select: 'Sélectionner',
    view: 'Voir',
    delete: 'Effacer',
    update: 'Mise à jour',
    edit: 'Modifier',
    submit: 'Soumettre',
    confirm: 'Confirmer',
    next: 'Prochain',
    previous: 'Précédent',
    checkout: 'Vérifier',
    add_card: 'Ajouter identifiant',
    dismiss: 'Rejeter',
    add_user: 'Ajouter utilisateur',
    enable: 'Activer',
    disable: 'Désactiver',
    done: 'Terminer',
    remove: 'Retirer',
    reset: "Réinitialiser à l'état normal",
    lock: 'Verrouillage (surpasser)',
    unlock: 'Déverrouiller (surpasser)',
    grant_access: "Accorder l'accès",
    grant_extend: 'Accès étendu',
    actions: 'Actions',
    disabled: 'Désactivée',
    enable_access: 'Activé accés',
    disable_access: 'Désactivée accés',
    register: "S'inscrire",
    refresh: 'Actualiser',
    restore: 'Restaurer',
    send: 'Envoyer',
    test: 'Test',
    list_view: 'Vue en liste',
    chart_view: 'Vue graphique',
    default: 'Défaut',
    go_back: 'Retourner',
    now: 'Maintenant',
    later: 'Plus tard',
    resend: 'Renvoyer',
    add: 'Ajouter',
    ok: 'OK',
    apply: 'Appliquer',
  },
  form: {
    timezone: 'Fuseau horaire',
  },
  month: {
    january: 'Janvier',
    february: 'Février',
    march: 'Mars',
    april: 'Avril',
    may: 'Mai',
    june: 'Juin',
    july: 'Juillet',
    august: 'Août',
    september: 'Septembre',
    october: 'Octobre',
    november: 'Novembre',
    december: 'Décembre',
  },
  day_name: {
    sunday: 'Dimanche',
    monday: 'Lundi',
    tuesday: 'Mardi',
    wednesday: 'Mercredi',
    thursday: 'Jeudi',
    friday: 'Vendredi',
    saturday: 'Samedi',
  },
  cardinal: {
    first: 'Premier',
    second: 'Deuxième',
    third: 'Troisième',
    fourth: 'Quatrième',
    last: 'Dernier',
  },
  aria_expand_row: 'Développer la ligne',
  aria_breadcrumb: "Fil d'Ariane",
  aria_choices: 'Choix',
  aria_options: 'Options',
  options_label: 'Options',
  options_label_2: 'Options 2',
  checkbox_options_label: 'Options case à cocher',
  status_ok: 'État : OK',
  error_fallback_title: "Oups ! Une erreur s'est produite.",
  error_fallback_message:
    'Le problème a été signalé à notre équipe et sera résolu dès que possible. Merci de votre patience.',
  event_id: "ID d'événement",
  error_selecting_image: 'Erreur lors de la sélection du fichier image',
  date_filter: {
    all: 'Tous',
    this_week: 'Cette semaine',
    last_week: 'La semaine dernière',
    this_month: 'Ce mois-ci',
    last_month: 'Le mois dernier',
    this_year: 'Cette année',
    last_7_days: 'Les 7 derniers jours',
    last_30_days: 'Les 30 derniers jours',
    last_60_days: 'Les 60 derniers jours',
    last_90_days: 'Les 90 derniers jours',
    last_180_days: 'Les 180 derniers jours',
    custom: 'Personnalisé',
    range: 'De {{ from }} à {{ to }}',
    from: 'De {{ from }}',
    to: 'À {{ to }}',
  },
};

export default general;
